import React, { FC } from 'react';
import YouTube, { Options } from 'react-youtube';

import Image from 'common/Image';

import { YouTubeLazyLoadedProps } from './models';

import './YouTubeLazyLoaded.scss';

const YouTubeLazyLoaded: FC<YouTubeLazyLoadedProps> = ({ videoId, videoPoster }) => {
  const [startYoutube, setState] = React.useState(false);
  const setStartYoutube = () => {
    setState(true);
  };

  const videoOpts: Options = {
    playerVars: {
      controls: 1,
      autoplay: 1,
      loop: 1,
      showinfo: 0,
      modestbranding: 1,
    },
  };
  if (!videoPoster || !videoId) return null;

  return (
    <div className="video-wrapper">
      {startYoutube && <YouTube videoId={videoId} opts={videoOpts} />}
      {!startYoutube && (
        <div role="button" onClick={setStartYoutube} onKeyDown={setStartYoutube} tabIndex={0}>
          <Image imageData={videoPoster} alt={videoPoster.altText} />
          <i className="fab fa-youtube" />
        </div>
      )}
    </div>
  );
};

export default YouTubeLazyLoaded;
